var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketPromedio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket-promedio",
    transform: "translate(-0.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1883",
    "data-name": "Rect\\xE1ngulo 1883",
    transform: "translate(0.478)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bill-check-svgrepo-com",
    transform: "translate(11.21 8.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27320",
    "data-name": "Trazado 27320",
    d: "M31.786,9.721V8.748a11.853,11.853,0,0,0-.253-3.506,4.783,4.783,0,0,0-3.009-2.991A12.067,12.067,0,0,0,25,2H9.789a12.067,12.067,0,0,0-3.527.251A4.783,4.783,0,0,0,3.253,5.242,11.856,11.856,0,0,0,3,8.748V22.074M31.786,15.9V30.372a1.546,1.546,0,0,1-2.572,1.148,1.552,1.552,0,0,0-2.053,0l-.773.683a2.72,2.72,0,0,1-3.6,0,2.72,2.72,0,0,0-3.6,0,2.72,2.72,0,0,1-3.6,0,2.72,2.72,0,0,0-3.6,0,2.72,2.72,0,0,1-3.6,0l-.773-.683a1.552,1.552,0,0,0-2.053,0A1.546,1.546,0,0,1,3,30.372V28.25",
    transform: "translate(-3 -2)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27321",
    "data-name": "Trazado 27321",
    d: "M9.5,11.706l2.285,2.471L17.5,8",
    transform: "translate(0.895 1.265)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27322",
    "data-name": "Trazado 27322",
    d: "M7.5,15.5H9.9m11.994,0H14.7",
    transform: "translate(-0.304 5.346)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketPromedio);
export default __webpack_public_path__ + "static/media/ticket-promedio.7de8c0c514d0fe25be215372add01e01.svg";
export { ForwardRef as ReactComponent };